interface BuildTranslatedDownloadNameOptions {
  separator?: '_' | '-'
  variant: 'mono' | 'dual'
  convertImageExtToPdf?: boolean
  maxBaseLength?: number
}

export const useDownloadFileName = () => {
  const appDomains = useAppDomainConfig()

  const buildTranslatedDownloadName = (
    originalName: string,
    targetLangCode?: string,
    options?: BuildTranslatedDownloadNameOptions,
  ) => {
    if (!originalName || !targetLangCode) {
      return originalName
    }

    const lastIndex = originalName.lastIndexOf('.')
    if (lastIndex < 0) {
      return originalName
    }

    let ext = originalName.slice(lastIndex).toLowerCase()
    if (options?.convertImageExtToPdf && ['.png', '.jpeg', '.jpg'].includes(ext)) {
      ext = '.pdf'
    }

    const separator = options?.separator || '-'
    const maxBaseLength = options?.maxBaseLength ?? 100
    const baseName = originalName.slice(0, lastIndex).slice(0, maxBaseLength)
    const brandSuffix = appDomains.fileBrandSuffix.value ? `_${appDomains.fileBrandSuffix.value}` : ''

    return `${baseName}${separator}${targetLangCode}_${options?.variant || 'mono'}${brandSuffix}${ext}`
  }

  return {
    buildTranslatedDownloadName,
  }
}
